import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSmartScroll } from "@/lib/useSmartScroll";

/**
 * Bottom CTA card used at the end of every detail page.
 * Anchors the user to run the Friction Audit next.
 */
const PageCTA = ({ heading, sub, primaryLabel = "Start Friction Audit", primaryHash = "#friction-audit", secondary }) => {
  const smart = useSmartScroll();

  return (
    <section data-testid="page-cta" className="relative py-24 lg:py-32 bg-[#0A0F1C] border-t border-white/10">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <div className="flex items-center justify-center gap-4 mb-6">
          <div className="h-px w-8 bg-nex-gold" />
          <span className="mono-label">// Next Step</span>
          <div className="h-px w-8 bg-nex-gold" />
        </div>
        <h2 className="serif-head text-3xl md:text-5xl mb-5">{heading}</h2>
        {sub && <p className="text-nex-chrome text-lg leading-relaxed max-w-2xl mx-auto mb-10">{sub}</p>}
        <div className="flex flex-wrap justify-center gap-4">
          <button
            data-testid="page-cta-primary"
            onClick={() => smart(primaryHash)}
            className="tick-btn-primary"
          >
            {primaryLabel} <ArrowRight size={16} />
          </button>
          {secondary && (
            <Link
              to={secondary.to}
              data-testid="page-cta-secondary"
              className="tick-btn-secondary"
            >
              {secondary.label}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageCTA;
